import styled from 'styled-components'
import formatContent from '@/utils/format-content'
import { useAddendumModal } from '../context'

const ContentInner = styled.div`
  max-width: 540px;
  width: 100%;
`

const Wrapper = styled.div`
  .leftside {
    text-align: left !important;
    width: 50% !important;
  }
`

const View = ({ addendumState }) => {
  const { variables } = useAddendumModal()
  return (
    <ContentInner>
      <Wrapper
        dangerouslySetInnerHTML={{
          __html: formatContent(addendumState?.content, variables)
        }}
      />
    </ContentInner>
  )
}

export default View
